import type { Dictionary } from "./locales/ro";

export type { Dictionary };

export const LANGS = ["ro", "en", "es", "it", "pl", "hu", "cs", "bg", "pt"] as const;
export type Lang = (typeof LANGS)[number];

export const DEFAULT_LANG: Lang = "ro";
export const NON_DEFAULT_LANGS: Lang[] = LANGS.filter((l) => l !== DEFAULT_LANG);

export const isLang = (value: string | undefined): value is Lang =>
  !!value && (LANGS as readonly string[]).includes(value);

// Native name + flag-icons country code for the language switcher.
export const LANG_META: Record<Lang, { name: string; flag: string }> = {
  ro: { name: "Română", flag: "ro" },
  en: { name: "English", flag: "gb" },
  es: { name: "Español", flag: "es" },
  it: { name: "Italiano", flag: "it" },
  pl: { name: "Polski", flag: "pl" },
  hu: { name: "Magyar", flag: "hu" },
  cs: { name: "Čeština", flag: "cz" },
  bg: { name: "Български", flag: "bg" },
  pt: { name: "Português", flag: "pt" },
};

// Map a raw navigator/Accept-Language tag (e.g. "en-US", "pt-BR") to a supported Lang.
export const normalizeLang = (raw: string | undefined): Lang | undefined => {
  if (!raw) return undefined;
  const base = raw.toLowerCase().split("-")[0];
  return (LANGS as readonly string[]).includes(base) ? (base as Lang) : undefined;
};
